import { isNil } from 'lodash';
import userService from 'services/userService';
import useSWR from 'swr';
import type { AxiosError } from 'axios';
import type { Paginator } from 'services/dtoModels/paginator';
import type { GetUsersRequest } from 'services/dtoModels/user/getUsersRequest';
import type { SWRResponse } from 'swr';

type SWRUsersData = Awaited<ReturnType<typeof userService.getUsersAsync>>;

const useUsers = (
  request: GetUsersRequest & Paginator,
  load = true
): SWRResponse<SWRUsersData, AxiosError> =>
  useSWR(
    !isNil(load) && load ? [SWR_USERS_ENDPOINT, request] : null,
    async ([_, params]) => await userService.getUsersAsync(params)
  );

export const SWR_USERS_ENDPOINT = 'users';
export default useUsers;
